import { Injectable } from '@angular/core';
import { BaseService } from '../../core-module/services/base.service';
import {
  WaHelperService, ViewDataService, FiltersComponentInterface, FiltersTypeEnum, IFilterComboComponent, IFilterDateComponent,
  IFilterTextComponent, IFilterRangeDateComponent, CountryNamesListLocator,
  CompetitionDisciplinesLocator,
  IFilterRangeSimpleComponent,
  CompetitionLevelsLocator,
  DivisionCategoryListLocator,
  DivisionCategoryItem,
  RankSortingLocatorComponent
} from 'world-archery-lib';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { first, map, debounceTime, filter } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { CountryCombo } from '../../../common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';

/**
 * Filter service for use into the module of calendar
 *
 * @export
 * @class CalendarFilterService
 * @extends {BaseService}
 */
@Injectable({
  providedIn: 'root'
})
export class CalendarFilterService extends FiltersAbstractService {

  countryCombo = new CountryCombo('Country:', 'country-combo', this.http, [{ item: { CShort: 'All countries' }, position: 0 }], 'country', true, true);

  /**
   * Filters properties
   *
   * @type {*}
   * @memberof CalendarFilterService
   */
  filtersType: any = [
    {
      options: {
        type: FiltersTypeEnum.TextSearch,
        intercept_name: 'search',
        id: 'wrankingextfilter',
        defaultTextValue: '',
        text_subject: new BehaviorSubject('')
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name: 'discipline',
        name_filter: 'Discipline:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All disciplines' }
        ]),
        option_name_property: 'discipline',
        options_selected_subject: new BehaviorSubject<any>({
          name: 'Outdoor'
        } as any),
        id: 'wrankingdisciplinecombo'
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name: 'world_ranking',
        name_filter: 'World ranking:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All' },
          { name: 'Yes' },
          { name: 'No' }
        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({
          name: 'Individual'
        } as any),
        id: 'wrankingworldrankingeventcombo'
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name: 'world_record',
        name_filter: 'World record:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All' },
          { name: 'Yes' },
          { name: 'No' }
        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({} as any),
        id: 'wrankingworldrecordcategoriescombo'
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name: 'bowstyles',
        name_filter: 'Bowstyles:',
        options_subject: new BehaviorSubject<Array<any>>([
        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({} as any),
        id: 'wrankingbowstylescategoriescombo'
      }
    },
    {
      options: {
        type: FiltersTypeEnum.ComboBox,
        intercept_name: 'level',
        name_filter: 'Level:',
        options_subject: new BehaviorSubject<Array<any>>([
          { name: 'All levels', id: [undefined] },
          { name: 'International events', id: [1, 2, 3, 4, 8] },
          { name: 'Continental events', id: [5, 6, 7] },
          { name: 'National events', id: [9, 10] }

        ]),
        option_name_property: 'name',
        options_selected_subject: new BehaviorSubject<any>({ name: 'All levels' } as any),
        id: 'wrankinglevelcategoriescombo'
      }
    },
    this.countryCombo.filterInfo,
    {
      options: {
        type: FiltersTypeEnum.RangeDateSimpleFilter,
        date_from: {
          intercept_name: 'date_from',
          type: FiltersTypeEnum.DateFilter,
          date_format: 'dd MMMM yyyy',
          placeholder: 'From:',
          date_subject: new BehaviorSubject<any>(this.getDateDefault()),
          id: 'wrankingdatefromcombo'
        } as any,
        date_to: {
          type: FiltersTypeEnum.DateFilter,
          date_format: 'dd MMMM yyyy',
          intercept_name: 'date_to',
          placeholder: 'To:',
          date_subject: new BehaviorSubject<any>({}),
          id: 'wrankingdatetocombo'
        } as any
      }
    }

  ];


  data_for_categories: Array<DivisionCategoryItem> = [];

  /**
   * Get default date for filters.
   *
   * @return Date
   *   From now.
   */
  getDateDefault() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return { value: date };
  }

  constructor(
    helper: WaHelperService,
    private views: ViewDataService,
    private http: HttpClient
  ) {
    super();
    this.generateDefaultValues();
    this.sortLocator.asc = true;


  }

  /**
   * Generate the default values of the combos
   *
   * @memberof CalendarFilterService
   */
  generateDefaultValues() {
    //Bowstyles
    const divisionLocator = new DivisionCategoryListLocator();
    const disciplineView = this.views.get(divisionLocator);
    disciplineView.getDataStream().pipe(first()).subscribe(next => {
      const data = [{ id: undefined, name: "All bowstyles", 'viewOrder': 0 }].concat(next);
      (<IFilterComboComponent>(
        this.filtersType[4].options
      )).options_subject.next(data);

      this.data_for_categories = next;
    })
    // Disciplines:
    const disciplinesLocator = new CompetitionDisciplinesLocator();
    const disciplinesView = this.views.get(disciplinesLocator);
    disciplinesView.getDataStream().pipe(first()).subscribe(next => {
      const data = [{ id: '', discipline: "All disciplines", 'viewOrder': 0 }].concat(next);
      (<IFilterComboComponent>(
        this.filtersType[1].options
      )).options_subject.next(data);


    });

  }

  /**
   * Get the data stream of filters when they change
   *
   * @returns {(Observable<{
   *     text: string,
   *     discipline: string,
   *     world_ranking: boolean,
   *     world_record: boolean,
   *     bowstyles: string,
   *     level: Array<number | undefined>,
   *     country: string,
   *     date: { begin: Date, end: Date },
   *     RankSortingLocatorComponent: any
   *
   *   }>)}
   * @memberof CalendarFilterService
   */
  public getDataStreamWithFilters(): Observable<{
    text: string,
    discipline: string,
    world_ranking: number,
    world_record: number,
    bowstyles: string,
    level: Array<number | undefined>,
    country: string,
    date: { begin: Date, end: Date },
    order: Observable<RankSortingLocatorComponent>

  }> {
    return combineLatest(
      (<IFilterTextComponent>(
        this.filtersType[0].options
      )).text_subject.asObservable().pipe(debounceTime(300)),
      (<IFilterComboComponent>(
        this.filtersType[1].options
      )).options_selected_subject.asObservable(),

      (<IFilterComboComponent>(
        this.filtersType[2].options
      )).options_selected_subject.asObservable(),
      (<IFilterComboComponent>(
        this.filtersType[3].options
      )).options_selected_subject.asObservable(),
      (<IFilterComboComponent>(
        this.filtersType[4].options
      )).options_selected_subject.asObservable(),
      (<IFilterComboComponent>(
        this.filtersType[5].options
      )).options_selected_subject.asObservable(),
      (<IFilterComboComponent>(
        this.filtersType[6].options
      )).options_selected_subject.asObservable(),
      (<IFilterRangeDateComponent>(
        (<any>this.filtersType[7].options as any).date_from
      )).date_subject.asObservable(),
      (<IFilterRangeDateComponent>(
        (<any>this.filtersType[7].options as any).date_to
      )).date_subject.asObservable(),
      this.orderValue,
      // ).pipe(map(([text, discipline, world_ranking, world_record, bowstyles, level, country, date, sort]) => {
    ).pipe(map(([text, discipline, world_ranking, world_record, bowstyles, level, country, date_from, date_to, sort]) => {
      // Default values for sorts.
      if (sort.sortingType == undefined) {
        sort.sortingType = 'DATE';
      }
      const ret = {
        date: { begin: date_from ? date_from.value : undefined, end: date_to ? date_to.value : undefined },
        text: text,
        discipline: discipline ? discipline.id : undefined,
        world_ranking: world_ranking.name === 'All' ? 0 : world_ranking.name == 'Yes' ? 1 : -1,
        world_record: world_record.name === 'All' ? 0 : world_record.name == 'Yes' ? 1 : -1,
        bowstyles: bowstyles ? bowstyles.id ? bowstyles.id : undefined : undefined,
        level: level ? level.id : undefined,
        country: country ? country.map(value=> value.NOC).filter(Boolean).join('|') : undefined,
        order: sort.sortingSend
      };
      return ret;
    }))
  }

  /**
   * Get the name of categories by id
   *
   * @param {number} item
   * @returns
   * @memberof CalendarFilterService
   */
  getNameOfCategories(item: number) {
    return this.data_for_categories.find(value => value.id === item).name ? this.data_for_categories.find(value => value.id === item).name : undefined;
  }

}
